module.exports = __webpack_public_path__ + "img/boda-preparacion-Shirel.ff2cd947.jpg";